module.exports = __webpack_public_path__ + "img/Flag_of_Botswana.fa28fdc9.svg";